package music.jammers.client.shared.signin

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource

@Composable
internal fun GoogleButtonUI(
    progress: Boolean,
    onClick: () -> Unit,
    iconDrawable: DrawableResource,
    modifier: Modifier = Modifier,
) {
    Box(
        modifier = modifier
    ) {
        if (progress) {
            CircularProgressIndicator(
                color = MaterialTheme.colorScheme.primary
            )
        } else {
            Box(
                modifier = Modifier
                    .clip(shape = CircleShape)
                    .background(Color.White)
                    .padding(8.dp)
                    .clickable(onClick = onClick)
            ) {
                Image(
                    painter = painterResource(iconDrawable),
                    contentDescription = "GoogleButton",
                )
            }
        }
    }
}